import { gql } from '@apollo/client'
import { CHATBOT_QUICK_PROMPT_FIELDS } from './fragments/chatbot_quick_prompt'

export const UPDATE_CHATBOT_QUICK_PROMPT = gql`
  ${CHATBOT_QUICK_PROMPT_FIELDS}
  mutation updateChatbotQuickPrompt($id: ID, $title: String, $text: String) {
    updateChatbotQuickPrompt(id: $id, title: $title, text: $text) {
      ...ChatbotQuickPromptFields
    }
  }
`
